const colors = {
  white: "#FFFFFF",
  azure: "#3B82F6",
  kellyGreen: "#36B22D",
  frenchBlue: "#1976D2",
  greenBlue: "#1565C0",
  black: "#000000",
  nero: "#212121",
  fringyFlower: "#BDE8BB",
  whiteSmoke: "#F5F5F5",
  eclipse: "#3A3838",
  solitude: "#E9ECEF",
  lightGrey: "#F4F4F4",
  cello: "#3D5265",
  grayChateau: "#9BA0A3",
  dimGray: "#707070",
  limeade: "#509E2F",
  red: "#FF0000",
  whisper: "#E6E6E6",
  pacificBlue: "#00A5E3",
  alizarin: "#ED1C24",
  comet: "#6D6D75",
  tintsOfRed: "#FE0000",
  tintsOfOrange: "#FFA500",
  cobalt: "#0056B3",
  veryLightGrey: "#C8C6C6",
  dodgerBlue: "#007BFF",
  inchWorm: "#97D700",
  dew: "#EDF9F0",
  japaneseLaurel: "#287D3C",
  fruitSalad: "#4CAF50",
  fruitSaladAlt: "#45A049",
  nightRider: "#333333",
  pelorous: "#17A2B8",
  aliceBlue: "#F4F8FB",
  aliceBlueAlt: "#F5F9FC",
  pattensBlue: "#D8E7F3",
  chateauGreen: "#28A745",
  silver: "#BFBFBF",
  bostonBlue: "#44A4AA",
  mariner: "#365D9E",
  quartz: "#E0E0E2",
  nobel: "#9D9999",
  ghost: "#C1C1C7",
  tara: "#D7F5D5",
  grey: "#767676",
  venetianRed: "#C00D15",
  ghostWhite: "#F2F2F3",
  grannySmithApple: "#9AD895",
  honeydew: "#EFF9EE",
  shipCove: "#7E84A3",
  dolphin: "#727276",
  sangria: "#90090F",
  veryLightGray: "#ccc",
  kashmirBlue: "#56728C",
  arsenic: "#314252",
  green: "#0E8103",
  kournikova: "#FFCB4C",
  carmine: "#A40D15",
  gainsboro: "#E0E0E0",
  jade: "#00C37A",
  darkCerulean: "#004B87",
  onahau: "#B8E0EF",
  geraldine: "#EB6A6A",
  harvestGold: "#EABF68",
  islamicGreen: "#0EA600",
};

export { colors };
